import { createI18n } from "vue-i18n";

function sanitizeLocale(input?: string) {
  const v = (input || "").toLowerCase();
  return /^[a-z]{2}$/.test(v) ? v : "en";
}

async function loadMessages(locale: string) {
  try {
    const mod = await import(/* @vite-ignore */ `./locales/${locale}.json`);
    return mod.default || mod;
  } catch {
    const mod = await import("./locales/en.json");
    return mod.default || mod;
  }
}

export async function createI18nFor(rawLocale?: string) {
  const locale = sanitizeLocale(rawLocale);
  const messages = await loadMessages(locale);

  return createI18n({
    legacy: false,
    locale,
    fallbackLocale: "en",
    messages: { [locale]: messages }
  });
}
